import { type PropsWithChildren, type FC } from 'react';
import { Spinner } from 'react-bootstrap';

import { colors } from '@editor2/styles/colors';

interface IProps extends PropsWithChildren {
	loading: boolean;
	height?: string;
}

const LoaderWrapper: FC<IProps> = (props) => {
	const { loading, height = '100vh', children } = props;

	return loading ? (
		<div
			className="d-flex justify-content-center align-items-center"
			style={{ height: `${height}`, color: `${colors.mainText}` }}>
			<Spinner animation="border" role="status" />
		</div>
	) : (
		<>{children}</>
	);
};

export default LoaderWrapper;
